import { Component, ViewChild, ElementRef, ViewEncapsulation } from "@angular/core";
import { ILoadingOverlayAngularComp } from "ag-grid-angular";
import { ILoadingOverlayParams, IAfterGuiAttachedParams } from "ag-grid-community";

// Customizing ag-grid overlay component
// https://www.ag-grid.com/javascript-grid-overlay-component/
@Component({
  selector: "lib-custom-loading-overlay",
  template:
    `<lib-progress
       #loadingSpinner
       [id]="'spinner'"
       [loader]="false"
       [spinner]="true"
       [spinnerPosition]="'center'">
     </lib-progress>`,
  styleUrls: ["./custom-loading-overlay.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class CustomLoadingOverlayComponent implements ILoadingOverlayAngularComp {

  @ViewChild("loadingSpinner", { static: true }) spinnerRef;
  private params: ILoadingOverlayParams;

  constructor() { }

  agInit(params: ILoadingOverlayParams): void {
    this.params = params;

    // start the spinnning action
    this.spinnerRef.start();
  }

}
